// Check if 'vacancyOverviewURL' is stored in sessionStorage
const storedURL = sessionStorage.getItem('vacancyOverviewURL');

if (storedURL) {
    const backToOverviewBtn = document.querySelector('[data-vacancy-overview-url]');
    if (backToOverviewBtn) {
        backToOverviewBtn.href = storedURL;
    }
}

const throttle = (fn, delay) => {
    let time = Date.now();

    return () => {
        if ((time + delay - Date.now()) <= 0) {
            fn();
            time = Date.now();
        }
    }
}

(function () {
    const jobActionsStickyBtns = document.querySelectorAll('[data-sticky-btns]');
    const jobDetailHeader = document.querySelector('[data-job-detail-header]');
    const siteFooter = document.querySelector('.site-footer');

    // How early the buttons appear, in px.
    // Higher = earlier (they show while this much of the header is still visible).
    const SHOW_OFFSET_DESKTOP = 232;
    const SHOW_OFFSET_MOBILE = 360;
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    if (jobActionsStickyBtns.length > 0 && jobDetailHeader && siteFooter) {
        const updateStickyVisibility = () => {
            const showOffset = mobileQuery.matches ? SHOW_OFFSET_MOBILE : SHOW_OFFSET_DESKTOP;

            const heroOutOfView = jobDetailHeader.getBoundingClientRect().bottom < showOffset;
            const footerRect = siteFooter.getBoundingClientRect();
            const footerInView = footerRect.top < window.innerHeight && footerRect.bottom > 0;

            const shouldShow = heroOutOfView && !footerInView;
            jobActionsStickyBtns.forEach((btn) => {
                btn.classList.toggle('show', shouldShow);
            });
        };

        updateStickyVisibility();
        window.addEventListener('scroll', throttle(updateStickyVisibility, 100));
        window.addEventListener('resize', throttle(updateStickyVisibility, 100));
    }
})();